import { ActionTypes } from "./actionTypes";


const initialState = {
  appData: {},
  formData: {
    defaultRegion: "US & Canada",
  },
  showModal: false,
  authVariant: "student",
  showSignUpModal: false,
  showMentorSignUpModal: false,
  isFetching: false,
  announcement: null,
  regions: null,
  testimonials: [],
  referrals: [],
  error: null,
  userType: null,
  courseCarouselData: null,
  courseSchedules: null,
  brochure: null,
  successStories: [],
  courses: null,
  courseInstructors: null,
  bannerData: null,
  promotionData: null,
  prices: [],
  googleRatings: null,
  isAuthenticated: false,
  user: null,
  userEmail: "",
  courseGroups: null,
  faqs: [],
  startLearnings: [],
  courseTypes: [],
  cardsOnly: [],
  mentors: [],
  mentor: null,
  mentorError: null,
  upcomingSessions: {},
  upcomingSessionsError: null,
  pastSessions: [],
  pastSessionsError: null,
  isLoggedIn: false,
  selectedMentor: null,
  bookings: {
    upcomingBookings: [],
    pastBookings: [],
    isLoading: false,
    error: null,
  },
  review: {
    isSubmitting: false,
    error: null,
    data: null,
  },
  dashboard: {
    speakToAdvisor: null,
    joinCommunityLink: null,
  },
  reminder: {
    isSetting: false,
    error: null,
    success: false,
  },
  courseReviews: {
    data: [],
    isFetching: false,
    error: null,
  },
  // UNIFIED ACCOUNT: Student and mentor experience state
  experiences: {
    student: { active: false, enrolledCoursesCount: 0 },
    mentor: {
      active: false,
      applicationStatus: null,
      hasProfile: false,
      profileCompletionPercentage: 0,
      submittedAt: null,
      approvedAt: null,
      rejectedAt: null,
      rejectionReason: null,
    },
  },
  experiencesLoading: false,
  experiencesError: null,
};

// Helper function to add bookings data
const setBookingsData = (state, { upcomingBookings, pastBookings }) => {
  return {
    ...state,
    bookings: {
      ...state.bookings,
      upcomingBookings: upcomingBookings || [],
      pastBookings: pastBookings || [],
      isLoading: false,
      error: null,
    },
  };
};

// Pure reducer function to handle state transitions
function appReducer(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case ActionTypes.SET_APP_DATA:
      return {
        ...state,
        appData: {
          ...state.appData,
          ...action.hash,
        },
      };
    case ActionTypes.SET_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.hash,
        },
      };
    case ActionTypes.SHOW_MODAL:
      return {
        ...state,
        showModal: true,
        authVariant: action.authVariant || "student",
      };
    case ActionTypes.SHOW_SIGNUP_MODAL:
      return {
        ...state,
        showSignUpModal: true,
      };
    case ActionTypes.SHOW_MENTOR_SIGNUP_MODAL:
      return {
        ...state,
        showMentorSignUpModal: true,
      };
    case ActionTypes.HIDE_MODAL:
      return {
        ...state,
        showModal: false,
        authVariant: "student",
        showSignUpModal: false,
        showMentorSignUpModal: false,
      };
    case ActionTypes.LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        isLoggedIn: true,
      };
    case ActionTypes.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        isLoggedIn: false,
        referrals: [],
      };
    case ActionTypes.SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    case ActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };
    case ActionTypes.GET_API_REQUEST:
      return {
        ...state,
        ...action.hash,
        isFetching: false,
      };
    case ActionTypes.SET_USER_EMAIL:
      return {
        ...state,
        userEmail: action.email,
      };
    case ActionTypes.RESET_USER_EMAIL:
      return {
        ...state,
        userEmail: "",
      };
    case ActionTypes.SET_USER_TYPE:
      return {
        ...state,
        userType: action.userType,
      };
    case ActionTypes.UPDATE_USER:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
          originalRegisteredRole:
            action.payload?.originalRegisteredRole ||
            state.user?.originalRegisteredRole,
        },
      };
    case ActionTypes.UPDATE_AVATAR:
      return {
        ...state,
        user: {
          ...state.user,
          avatarUrl: action.payload,
        },
      };
    case ActionTypes.GET_SINGLE_MENTOR_SUCCESS:
      return {
        ...state,
        mentor: action.payload,
        mentorError: null,
        isFetching: false,
      };
    case ActionTypes.GET_SINGLE_MENTOR_ERROR:
      return {
        ...state,
        mentor: null,
        mentorError: action.error,
        isFetching: false,
      };
    case "UPDATE_MENTOR_AVAILABILITY":
      return {
        ...state,
        mentor: state.mentor
          ? {
              ...state.mentor,
              availability: action.payload,
            }
          : null,
      };
    case ActionTypes.FETCH_UPCOMING_SESSIONS_SUCCESS:
      return {
        ...state,
        upcomingSessions: {
          ...state.upcomingSessions,
          [action.payload.mentorId]: action.payload.bookings,
        },
        upcomingSessionsError: null,
        isFetching: false,
      };
    case ActionTypes.FETCH_UPCOMING_SESSIONS_ERROR:
      return {
        ...state,
        upcomingSessionsError: action.error,
        isFetching: false,
      };
    // Past sessions actions
    case ActionTypes.FETCH_PAST_SESSIONS_SUCCESS:
      return {
        ...state,
        pastSessions: action.payload,
        pastSessionsError: null,
        isFetching: false,
      };
    case ActionTypes.FETCH_PAST_SESSIONS_ERROR:
      return {
        ...state,
        pastSessionsError: action.error,
        isFetching: false,
      };
    // Add new actions for bookings
    case ActionTypes.SET_USER_BOOKINGS:
      return setBookingsData(state, action.payload);
    case ActionTypes.BOOKINGS_LOADING:
      return {
        ...state,
        bookings: {
          ...state.bookings,
          isLoading: true,
        },
      };
    case ActionTypes.BOOKINGS_ERROR:
      return {
        ...state,
        bookings: {
          ...state.bookings,
          error: action.payload,
          isLoading: false,
        },
      };
    // Review submission actions
    case ActionTypes.SUBMIT_REVIEW_START:
      return {
        ...state,
        review: {
          ...state.review,
          isSubmitting: true,
          error: null,
        },
      };
    case ActionTypes.SUBMIT_REVIEW_SUCCESS:
      return {
        ...state,
        review: {
          isSubmitting: false,
          error: null,
          data: action.payload,
        },
      };
    case ActionTypes.SUBMIT_REVIEW_ERROR:
      return {
        ...state,
        review: {
          ...state.review,
          isSubmitting: false,
          error: action.payload,
        },
      };
    case ActionTypes.SET_EVENT_REMINDER_START:
      return {
        ...state,
        reminder: {
          ...state.reminder,
          isSetting: true,
          error: null,
          success: false,
        },
      };
    case ActionTypes.SET_EVENT_REMINDER_SUCCESS:
      return {
        ...state,
        reminder: {
          ...state.reminder,
          isSetting: false,
          error: null,
          success: true,
        },
      };
    case ActionTypes.SET_EVENT_REMINDER_ERROR:
      return {
        ...state,
        reminder: {
          ...state.reminder,
          isSetting: false,
          error: action.payload,
          success: false,
        },
      };
    case ActionTypes.FETCH_REFERRALS_SUCCESS:
      return {
        ...state,
        referrals: action.payload,
      };
    case ActionTypes.FETCH_COURSE_REVIEWS_START:
      return {
        ...state,
        courseReviews: {
          ...state.courseReviews,
          isFetching: true,
          error: null,
        },
      };
    case ActionTypes.FETCH_COURSE_REVIEWS_SUCCESS:
      return {
        ...state,
        courseReviews: {
          ...state.courseReviews,
          data: action.payload,
          isFetching: false,
          error: null,
        },
      };
    case ActionTypes.FETCH_COURSE_REVIEWS_ERROR:
      return {
        ...state,
        courseReviews: {
          ...state.courseReviews,
          isFetching: false,
          error: action.payload,
        },
      };
    case ActionTypes.SUBMIT_COURSE_REVIEW_START:
      return {
        ...state,
        review: {
          ...state.review,
          isSubmitting: true,
          error: null,
        },
      };
    case ActionTypes.SUBMIT_COURSE_REVIEW_SUCCESS:
      return {
        ...state,
        review: {
          ...state.review,
          isSubmitting: false,
          error: null,
          data: action.payload,
        },
      };
    case ActionTypes.SUBMIT_COURSE_REVIEW_ERROR:
      return {
        ...state,
        review: {
          ...state.review,
          isSubmitting: false,
          error: action.payload,
        },
      };
    // UNIFIED ACCOUNT: Experiences state
    case ActionTypes.FETCH_EXPERIENCES_START:
      return {
        ...state,
        experiencesLoading: true,
        experiencesError: null,
      };
    case ActionTypes.FETCH_EXPERIENCES_SUCCESS:
      return {
        ...state,
        experiences: action.payload,
        experiencesLoading: false,
        experiencesError: null,
      };
    case ActionTypes.FETCH_EXPERIENCES_ERROR:
      return {
        ...state,
        experiencesLoading: false,
        experiencesError: action.payload,
      };
    default:
      return state;
  }
}

export default appReducer;
